import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import tinymce from 'tinymce';
// import 'tinymce/themes/silver';  // Ensure you're loading the silver theme
// import 'tinymce/plugins/advlist';  // Import required plugins
// import 'tinymce/plugins/autolink';
// import 'tinymce/plugins/link';
// import 'tinymce/plugins/image';
// import 'tinymce/plugins/lists';
// import 'tinymce/plugins/charmap';
// import 'tinymce/plugins/print';
// import 'tinymce/plugins/preview';
// import 'tinymce/plugins/hr';
// import 'tinymce/plugins/anchor';
// import 'tinymce/plugins/pagebreak';
// import 'tinymce/plugins/spellchecker';
// import 'tinymce/plugins/searchreplace';
// import 'tinymce/plugins/wordcount';
// import 'tinymce/plugins/visualblocks';
// import 'tinymce/plugins/visualchars';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/fullscreen';
// import 'tinymce/plugins/insertdatetime';
// import 'tinymce/plugins/media';
// import 'tinymce/plugins/nonbreaking';
// import 'tinymce/plugins/table';
// import 'tinymce/plugins/contextmenu';
// import 'tinymce/plugins/directionality';
// import 'tinymce/plugins/emoticons';
// import 'tinymce/plugins/template';
// import 'tinymce/plugins/textcolor';
// import 'tinymce/plugins/paste';
// import 'tinymce/plugins/fontselect';
// import 'tinymce/plugins/fontsizeselect';


const TemplateLetterForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [operation, setOperation] = useState('Add');
  const [templateName, setTemplateName] = useState('');
  const [message, setMessage] = useState('');
  const [fieldList, setFieldList] = useState([
    { id: 1, field_description: 'Field 1', field_name: 'Field1' },
    { id: 2, field_description: 'Field 2', field_name: 'Field2' },
    { id: 3, field_description: 'Field 3', field_name: 'Field3' },
  ]);
  const [selectedField, setSelectedField] = useState('');

  useEffect(() => {
    if (id) {
      setOperation('Edit');
      // Set the template name and message with dummy data for editing
      setTemplateName('Template ' + id);
      setMessage('<p>This is the message content for template ' + id + '</p>');
    }
  }, [id]);

  useEffect(() => {
    tinymce.init({
      selector: '#message',
      plugins: [
        'advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker',
        'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking',
        'table contextmenu directionality emoticons template textcolor paste fontselect fontsizeselect',
      ],
      toolbar: [
        'bold italic underline | alignleft aligncenter alignright alignjustify | styleselect formatselect | fontselect fontsizeselect',
        'cut copy paste | searchreplace | bullist numlist | outdent indent blockquote | undo redo | link unlink anchor image media code | inserttime preview | forecolor backcolor',
        'table | hr removeformat | subscript superscript | charmap emoticons | print fullscreen | ltr rtl | spellchecker | visualchars visualblocks nonbreaking template pagebreak restoredraft',
      ],
      menubar: false,
      style_formats: [
        { title: 'Bold text', inline: 'b' },
        { title: 'Red text', inline: 'span', styles: { color: '#ff0000' } },
        { title: 'Red header', block: 'h1', styles: { color: '#ff0000' } },
        { title: 'UL', block: 'ul', classes: 'cla1', styles: { color: '#ff0000' } },
      ],
      templates: fieldList.map((post) => ({
        title: post.field_description,
        content: post.field_name,
      })),
    });
  
    return () => {
      tinymce.remove('#message');
    };
  }, [fieldList]);
  

  const handleFieldChange = (event) => {
    const selected = event.target.value;
    setSelectedField(selected);
    // Updating content in TinyMCE editor dynamically
    tinymce.activeEditor.setContent(selected);  // Setting the field data inside the editor
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission (you can send data to an API here)
    console.log('Form Submitted');
    navigate('/Settings/TemplateLetter'); // Redirect after submission
  };

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id || ''} />
            <div className="panel-heading border-0">
              <span className="panel-title">{`${operation} Template Letter - ${templateName}`}</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <label className="form-label semibold">Select Data</label>
                  <select
                    name="fieldlist"
                    id="fieldlist"
                    className="form-control"
                    onChange={handleFieldChange}
                  >
                    {fieldList.map((field) => (
                      <option key={field.id} value={field.field_name}>
                        {field.field_description}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <fieldset className="form-group">
                    <label className="form-label semibold">Field</label>
                    <label
                      className="form-control"
                      style={{ fontWeight: 'normal' }}
                      id="fielddata"
                    >
                      {selectedField}
                    </label>
                  </fieldset>
                </div>

                <div className="col-md-12">
                  <fieldset className="form-group">
                    <label className="form-label semibold">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-control"
                      placeholder="Enter Message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </fieldset>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <a href="#" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default TemplateLetterForm;
